var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 34.5C22.5 37.6826 23.7643 40.7348 26.0147 42.9853C28.2652 45.2357 31.3174 46.5 34.5 46.5C37.6826 46.5 40.7348 45.2357 42.9853 42.9853C45.2357 40.7348 46.5 37.6826 46.5 34.5C46.5 31.3174 45.2357 28.2652 42.9853 26.0147C40.7348 23.7643 37.6826 22.5 34.5 22.5C31.3174 22.5 28.2652 23.7643 26.0147 26.0147C23.7643 28.2652 22.5 31.3174 22.5 34.5Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 28.5V40.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.5H40.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 40.5H4.5C3.70435 40.5 2.94129 40.1839 2.37868 39.6213C1.81607 39.0587 1.5 38.2956 1.5 37.5V4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H25.758C26.5531 1.50017 27.3156 1.81596 27.878 2.378L33.622 8.122C34.184 8.6844 34.4998 9.44691 34.5 10.242V16.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.25C10.6483 11.25 10.7933 11.294 10.9167 11.3764C11.04 11.4588 11.1361 11.5759 11.1929 11.713C11.2497 11.85 11.2645 12.0008 11.2356 12.1463C11.2067 12.2918 11.1352 12.4254 11.0303 12.5303C10.9254 12.6352 10.7918 12.7067 10.6463 12.7356C10.5008 12.7645 10.35 12.7497 10.213 12.6929C10.0759 12.6361 9.95881 12.54 9.8764 12.4167C9.79399 12.2933 9.75 12.1483 9.75 12C9.75 11.8011 9.82902 11.6103 9.96967 11.4697C10.1103 11.329 10.3011 11.25 10.5 11.25Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.558 19.8L22.5 16.5C22.3649 16.2967 22.1821 16.1295 21.9677 16.013C21.7532 15.8965 21.5135 15.8341 21.2694 15.8313C21.0253 15.8286 20.7843 15.8855 20.5672 15.9972C20.3502 16.1088 20.1637 16.2718 20.024 16.472L16.024 22.174L13.56 20.2C13.3977 20.0699 13.2101 19.975 13.0091 19.9213C12.8082 19.8675 12.5982 19.8562 12.3926 19.888C12.1871 19.9198 11.9903 19.994 11.815 20.1059C11.6396 20.2178 11.4894 20.3649 11.374 20.538L7.5 28.5H16.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFileAdd);
export default __webpack_public_path__ + "static/media/ImageFileAdd.bbc76d92990537ab50efcdd02bf25db1.svg";
export { ForwardRef as ReactComponent };